import { IEventsTranslations } from '..';
import common from '../common/es';

const events: IEventsTranslations = {
  ...common,
  new: 'New event',
  edit: 'Edit event',
  create: 'Create',
  send_registration_invite: 'Send registration invite',
  email: 'Email',
  name: 'Name',
  name_placeholder: 'Enter event name',
  assign: 'Assign',
  delete_manager: 'Delete event manager',
  no_managers_assigned: 'This event has no event managers assigned',
  start_date: 'Start date',
  end_date: 'End date',
  capacity: 'Capacity',
  location: 'Location',
  location_placeholder: 'Enter event location',
  is_published: 'Is published',
  base_cost: 'Base cost',
  max_capacity: 'Max capacity',
  delete: 'Delete',
  assign_manager: 'Assign event manager (select 1 event only)',
  manager: 'Event manager',
  select_manager: 'Select event manager',
  timezone: 'Timezone',
  europe: 'Europe',
  lisbon: 'Lisbon',
  london: 'London',
  madrid: 'Madrid',
  berlin: 'Berlin',
  default_language: 'Default language',
  portuguese: 'Portuguese',
  spanish: 'Spanish',
  english: 'English',
  german: 'German',
  french: 'French',
  description: 'Description',
  description_placeholder: 'Enter an event description',
  image: 'Image',
  image_placeholder: 'Click to upload image',
  background_image: 'Background image',
  background_image_placeholder: 'Click to upload background image',
  managers: 'Event managers',
  manager_email_placeholder: 'Enter user email',
  created_success: 'Event created successfuly',
  manager_added_success: 'Event manager added successfuly',
  manager_deleted_success: 'Event manager deleted successfuly',
  manager_user_not_exists: 'User does not exist. Make sure you typed the email correctly or send a registration invitation to this email.',
  manager_setup: 'Choose name and password',
  manager_user_password: 'Password',
  manager_user_name_placeholder: 'Enter user name',
  manager_user_password_placeholder: 'Enter user password',
  booklet: 'Booklet',
  setup_booklet: 'Set up booklet',
  title: 'Title',
  title_placeholder: 'Enter booklet title',
  cover: 'Cover',
  cover_placeholder: 'Upload booklet cover image',
  no_fields_selected: 'No fields selected.',
  drag_drop_fields: 'Drag and drop fields to set order.',
  configure_booklet: 'If you want to send a booklet when the event ends please configure it.',
  fields: 'Fields',
  create_booklet_success: 'Booklet created',
  create_booklet_error: 'Booklet creation failed',
  edit_booklet_success: 'Booklet edited',
  edit_booklet_error: 'Booklet editing failed',
  no_available_fields: 'No available fields',
  empty_space: 'Empty space',
  live_interactions_email: 'Live interactions email',
  account: 'Cuenta',
  assign_account: 'Asignar cuenta',
  select_account: 'Seleccionar cuenta',
  account_placeholder: 'Buscar una cuenta por nombre',
  account_assigned_success: 'Cuenta asignada con éxito',
};

export default events;
